import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { AppBar, Button, Toolbar, CircularProgress, Box } from '@mui/material';
import Progress from '../common/Progress';
import api from '../../api';
import ReceiveMethodEnum from '../../enums/ReceiveMethodEnum';
import CurrencyDisplay from '../common/CurrencyDisplay';

@inject('commonStore', 'menuStore', 'cartStore', 'userStore', 'orderStore')
@observer
class BottomPoint extends Component {
  componentDidMount() {
    // 페이지 접속 후에는 결제 상태 초기화
    this.props.orderStore.setDisablePaymentButton(false);
  }

  // 결제하기 버튼 클릭
  handleClickPay = async () => {
    const { t, history, location, match, commonStore, menuStore, userStore, orderStore, cartStore } = this.props;

    // (일본) 배달인 경우 주소 검사
    if (
      menuStore.storeData.culture === 'ja-JP' &&
      cartStore.cartData.receiveMethodCode === ReceiveMethodEnum.DELIVERY &&
      !userStore.userData.addressDetail
    ) {
      commonStore.setSnackbar(true, t('order.error.addressRequired'));
      return;
    }

    // 결제 버튼 비활성화 (중복결제방지)
    orderStore.setDisablePaymentButton(true);

    if (
      menuStore.storeData.isPointUseable &&
      orderStore.usePoint > 0 &&
      userStore.userPoint < menuStore.storeData.useableMinimumPoint
    ) {
      commonStore.setSnackbar(
        true,
        t('order.error.pointMinLimit', { n: Number(menuStore.storeData.useableMinimumPoint).toLocaleString() }),
      );
      orderStore.setDisablePaymentButton(false);
      return;
    }

    if (orderStore.paymentAmount > 0 && orderStore.paymentAmount < 100 && menuStore.storeData.culture !== 'ja-JP') {
      commonStore.setSnackbar(true, t('payment.error.minAmount'));
      orderStore.setDisablePaymentButton(false);
      return;
    }

    // 결제 금액이 0인 경우
    if (orderStore.paymentAmount === 0) {
      try {
        const response = await api.payOrderByPointOnly(orderStore.orderData);
        if (!response.data) throw new Error('포인트 결제 실패');
        if (orderStore.liteOrder) {
          // 마장동 주문일땐 화면 제한
          history.replace(
            `/${match.params.companyId}/${match.params.storeCode}/lite-orders/${response.data}/complete${location.search}`,
          );
        } else {
          history.replace(
            `/${match.params.companyId}/${match.params.storeCode}/orders/${response.data}/complete${location.search}`,
          );
        }
      } catch (error) {
        const searchParams = new URLSearchParams(window.location.search);
        if (error.response?.data?.errorCode) searchParams.set('errorCode', error.response.data.errorCode);
        history.replace(
          `/${match.params.companyId}/${match.params.storeCode}/errors/payment?${searchParams.toString()}`,
        );
      } finally {
        // 결제 버튼 활성화
        orderStore.setDisablePaymentButton(false);
      }
    } else {
      if (orderStore.paymentMethod === '0') {
        // 이지웰페이 결제
        this.payByEzwelPay();
      } else {
        // PG사별 결제
        this.props.pay();
      }
    }
  };

  payByEzwelPay = async () => {
    const { history, location, match, menuStore, orderStore } = this.props;

    try {
      // 이지웰페이 결제 준비 API 실행
      const response = await api.readyEzwelPay(orderStore.orderData);
      if (menuStore.storeData.ezwelPaySchemeType === '1') {
        window.location.href = response.data.next_redirect_mobile_url_intent;
      } else {
        window.location.href = response.data.next_redirect_mobile_url;
      }
    } catch (error) {
      console.error(error);
      history.replace(`/${match.params.companyId}/${match.params.storeCode}/errors/payment${location.search}`);
    } finally {
      // 결제 버튼 활성화
      orderStore.setDisablePaymentButton(false);
    }
  };

  render() {
    const { t, menuStore, cartStore, orderStore } = this.props;
    if (!menuStore.storeData || !cartStore.cartData) return <Progress />;
    return (
      <AppBar position="fixed" color="primary" className="bottom">
        <Toolbar variant="dense" style={{ padding: '0' }}>
          <Button
            fullWidth
            onClick={this.handleClickPay}
            disabled={orderStore.disablePaymentButton}
            className="bottom-button"
          >
            <Box className="bottom-button-title">
              {t('payment.button.pay')}
              {orderStore.disablePaymentButton && (
                <CircularProgress size={24} style={{ color: '#fff', marginLeft: '10px' }} />
              )}
            </Box>
            <Box bgcolor="secondary.main" className="bottom-button-amount">
              <CurrencyDisplay amount={orderStore.paymentAmount} size="large" />
            </Box>
          </Button>
        </Toolbar>
      </AppBar>
    );
  }
}

export default withRouter(withTranslation()(BottomPoint));
